import React from "react";
import { View, Text } from "@react-pdf/renderer";
import WhereMyDocumentsMayBeFoundStyles from "../Styles";
import { NameDateRow, TwoColumnLineRow } from "./FormFields";

const WhereMyDocumentsMayBeFound = ({ primaryColor = "081e56" }) => {
  const styles = WhereMyDocumentsMayBeFoundStyles(primaryColor);

  const rows = [
    {
      leftLabel: "My Deed / safe box may be found",
      rightLabel: "The Key may be found",
      leftLines: 2,
      rightLines: 1,
      showKeyNumber: true,
    },
    {
      leftLabel: "My Birth / Marriage Certificate May be Found",
      rightLabel: "My Passport May be Found",
      leftLines: 2,
      rightLines: 2,
    },
    {
      leftLabel: "My Life Insurance & Disability Policies May be Found",
      rightLabel: "My Car Insurance Policy May be Found",
      leftLines: 2,
      rightLines: 2,
    },
    {
      leftLabel: "My Home Contents Insurance May be Found",
      rightLabel: "My House Building Insurance May be Found",
      leftLines: 2,
      rightLines: 2,
    },
  ];

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>
        Where my Documents May be Found
      </Text>

      <View style={styles.panel}>
        <NameDateRow />

        {rows.map((r) => (
          <TwoColumnLineRow
            key={`${r.leftLabel}-${r.rightLabel}`}
            leftLabel={r.leftLabel}
            rightLabel={r.rightLabel}
            leftLines={r.leftLines}
            rightLines={r.rightLines}
            showKeyNumber={r.showKeyNumber}
          />
        ))}
      </View>
    </View>
  );
};

export default WhereMyDocumentsMayBeFound;
